import React from 'react';
import FormNosotros from '../../components/forms/formNosotros';

const EditNosotros = () => {
    return (
        <FormNosotros/>
    );
}
 
export default EditNosotros;